import { DegreeCompletion } from './../builders/degree_completion_builder';
import { ITransferDegreeCompletionDatasource } from './../datasources/transfer_degree_completion_datasource';
import { IQuery, IQueryMediator } from 'core-ts-types';

export class TransferDegreeCompletionQuery implements IQuery {
  private _result: Record<string, DegreeCompletion>;

  constructor(
    QueryMediator: IQueryMediator,
    private ngTransferDegreeCompletionDatasource: ITransferDegreeCompletionDatasource
  ) {
    QueryMediator.registerQuery(this, ngTransferDegreeCompletionDatasource);
  }

  run(): TransferDegreeCompletionQuery {
    const degreeCompletions = this.ngTransferDegreeCompletionDatasource.read();
    _.each(degreeCompletions, (majorAudit): void => {
      majorAudit.additional_courses = _.sortBy(majorAudit.additional_courses, 'display');
    });

    this._result = this.ngTransferDegreeCompletionDatasource.values().reduce((obj, item) => {
      return {
        ...obj,
        [item['degreeCompletionId']]: item
      };
    }, {});

    return this;
  }

  get result(): Record<string, DegreeCompletion> {
    return this._result;
  }
}

angular.module('capability-ng-transfer').service('ngTransferDegreeCompletionQuery', TransferDegreeCompletionQuery);



// WEBPACK FOOTER //
// ./app/lib/transfer/queries/transfer_degree_completion_query.ts